import moment from 'moment';
import { getMomentDateStringFromRangeArray } from '@/utils/dateUtil';
import { PPA_STLMTS_API } from '@/api';
import { clone } from '@/utils/dataUtil';

const state = {
  tableData: [],
  selectedRows: [],
};

const actions = {
  async fetchBDOverrides({ commit }, parameters = {}) {
    const { startDate, endDate } = getMomentDateStringFromRangeArray(parameters.tradeDateRangeSelected);
    const params = {
      ppas: parameters.ppasSelected,
      startDate,
      endDate,
      version: parameters.overrideVersionsSelected === 'MAX' ? -1 : parameters.overrideVersionsSelected,
    };
    try {
      const { data: { data } } = await PPA_STLMTS_API.post('/overrides/get', params);
      data.forEach((x) => {
        x.tradingDate = moment(x.tradingDate).utc().format('MM/DD/YYYY');
        x.createdDate = moment(x.createdDate).utc().format('MM/DD/YYYY');
        x.updatedDate = moment(x.updatedDate).utc().format('MM/DD/YYYY');
      });
      commit('setTableData', data);
    } catch {
      this.$notify('Failed to retrieve BD Overrides', 'error');
    }
  },
  async updateSelectedBDActiveFlag({ commit, state }, activeFlag) {
    const overrideRecords = clone(state.selectedRows);
    if (overrideRecords) {
      overrideRecords.forEach((bd) => { bd.activeFlag = activeFlag; });
      const params = {
        overrides: overrideRecords,
      };
      try {
        const { data: { data } } = await PPA_STLMTS_API.put('overrides/batch', params);
        commit('updateTable', data.overrides);
        this.$notify('Records Updated Successfully', 'success');
      } catch (error) {
        console.error(error);
        this.$notify('Records Updated Failed', 'error');
      }
    }
  },
  async addImportData({ commit, state }, fileData) {
    const importRecords = { Data: fileData };
    try {
      const { data } = await PPA_STLMTS_API.post('/overrides', importRecords);
      if (data?.success) {
        this.$notify('Records Created', 'success');
      } else {
        this.$notify(data?.message || 'Failed to Create Records', 'error');
      }
    } catch (err) {
      console.error(err);
      this.$notify('Failed to Create Records', 'error');
    }
  },
  reset({ commit }) {
    commit('setTableData', []);
  },
};

const mutations = {
  setTableData(state, value) {
    state.tableData = value;
  },
  setSelectedRows(state, value) {
    state.selectedRows = value;
  },
  updateTable(state, items) {
    const tableData = clone(state.tableData);
    for (let i = 0; i < items.length; i++) {
      const item = tableData.find((x) => x.Id === items[i].Id && x.ppaHeaderId === items[i].ppaHeaderId);
      if (item) {
        item.activeFlag = items[i].activeFlag;
      }
    }
    state.tableData = tableData;
  },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
};